import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { QueryKeys } from '../../shared';
import { IReport } from '../models/report.model';

async function getReport(id: string): Promise<IReport> {
    const { data } = await axios.get(`/reporting/reports/${id}`);
    return data;
}

export const useReport = (id: string) => {
    return useQuery<IReport, AxiosError>({ queryKey: [QueryKeys.Report, id], queryFn: () => getReport(id) });
};
